import { Dispatch, FC, SetStateAction } from 'react';
import { Avatar, Col, Row } from 'antd';
import { TbBriefcase, TbBuildingBank, TbChartLine, TbHierarchy, TbUsersGroup, TbUserStar } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import DashboardTemplateItem from '@/shared/components/modals/ResourceCreationModals/CreateDashboardModal/layout/DashboardTemplates/components/DashboardTemplateItem';

import { ROLE_TEMPLATES, RoleTemplate } from './roleTemplates';

interface RoleTemplatesProps {
    selectedTemplate: string;
    onSelect: (template: RoleTemplate) => void;
}

const RoleTemplates: FC<RoleTemplatesProps> = ({ onSelect, selectedTemplate }) => {
    const { token } = useAntDesignTheme();
    const icons = [TbChartLine, TbBriefcase, TbUserStar, TbHierarchy, TbBuildingBank, TbUsersGroup];

    const selectTemplate: Dispatch<SetStateAction<string>> = (nextTemplate) => {
        const templateKey = typeof nextTemplate === 'function' ? nextTemplate(selectedTemplate) : nextTemplate;
        const template = ROLE_TEMPLATES.find(({ key }) => key === templateKey);

        if (template) {
            onSelect(template);
        }
    };

    return (
        <Row gutter={[12, 12]} style={{ paddingTop: '0.5rem' }}>
            {ROLE_TEMPLATES.map((template, index) => {
                const Icon = icons[index];

                return (
                    <Col span={12} key={template.key}>
                        <DashboardTemplateItem
                            dt={{
                                ...template,
                                avatar: (
                                    <Avatar
                                        size='small'
                                        shape='square'
                                        icon={<Icon style={{ color: token.colorTextTertiary }} />}
                                        style={{
                                            border: `1px solid ${token.colorBorder}`,
                                            backgroundColor: token.colorBorderBg,
                                        }}
                                    />
                                ),
                            }}
                            dtIndex={index + 1}
                            template={selectedTemplate}
                            setTemplate={selectTemplate}
                        />
                    </Col>
                );
            })}
        </Row>
    );
};

export default RoleTemplates;
